'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const AppLayout = dynamic(() => import('@/components/AppLayout'), { ssr: false });
const WelcomeBanner = dynamic(() => import('./components/WelcomeBanner'), { ssr: false });
const ToolCategoryCards = dynamic(() => import('./components/ToolCategoryCards'), { ssr: false });
const RecentProjectsTable = dynamic(() => import('./components/RecentProjectsTable'), { ssr: false });
const CreatorInsightsPanel = dynamic(() => import('./components/CreatorInsightsPanel'), { ssr: false });

export default function UserDashboardPage() {
  return (
    <AppLayout currentPath="/user-dashboard">
      <div className="space-y-6">
        {/* Top row: Welcome banner + Creator Insights */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          {/* Left: Welcome + Tool Cards */}
          <div className="xl:col-span-2 space-y-5">
            <WelcomeBanner />
            <ToolCategoryCards />
          </div>
          {/* Right: Creator Insights */}
          <div className="xl:col-span-1">
            <CreatorInsightsPanel />
          </div>
        </div>

        {/* Recent Projects */}
        <RecentProjectsTable />
      </div>
    </AppLayout>
  );
}